// MyContext.js
import { createContext, useState } from 'react'

export const CaptchaTokenContext = createContext()

export const CaptchaTokenProvider = ({ children }) => {
  const [token, setToken] = useState('')
  const [uuid, setUuid] = useState('')
  const [isFormCompleted, setIsFormCompleted] = useState(false)
  return (
    <CaptchaTokenContext.Provider value={{ token, setToken, uuid, setUuid, isFormCompleted, setIsFormCompleted }}>
      {children}
    </CaptchaTokenContext.Provider>
  )
}
